import { apiAdd, apiDelete, apiGet, apiUpdate } from "../../../../API/Service/apiClient";
import { handleCheckUserLogin } from "../../../../MIS/Global";

export const handleGetOrder_list = async ({
  filter,
  setQuotations,
  setQuoteLoading,
}) => {
  setQuoteLoading(true);
  try {
    const resData = await apiGet("quotation", filter);
    setQuotations(resData?.data);
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setQuoteLoading(false);
  }
};

export const handleGetPrintType_list = async ({
  setLoading, setClothOptions
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("sublimation_print_type", {limit:100,page:1});
    setClothOptions(resData?.data);
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetPrintAddon_list = async ({
  setLoading, setPrintAddons,quote
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("sublimation_print_addon", {limit:100,page:1});
    let updatedData=[];
    if(quote?.length > 0){
      const quantityMap = Object.fromEntries(
        quote?.[0]?.prints?.map((q) => [
          q.print_addon_id,
          {
            addon_is: true           
          },
        ]));
      updatedData = resData?.data?.map((product) => {
          const details = quantityMap[product.id] || {};
          return {
            ...product,
            addon_is: details?.addon_is || false,            
          };
        });  
    }else{
      updatedData = resData?.data.map((item) => ({
        ...item,
        addon_is: false,        
      }));
    }
    setPrintAddons(updatedData);
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetClothType_list = async ({
  setLoading, setClothOptions,selectedCloth
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("sublimation_cloth", {limit:100,page:1});
    const resDataPrice = await apiGet("sublimation_price",
     {limit:100,page:1,print_type_id:selectedCloth?.id});
     const merged = resData?.data?.map((tItem) => {
      const match = resDataPrice?.data?.find(
        (sItem) => sItem.cloth_id === tItem.id
      );

      return match
        ? { ...tItem, sub_price: match.sub_price, print_type_id: selectedCloth?.id }
        : { ...tItem, sub_price: 0, print_type_id: selectedCloth?.id }; // unchanged if no match
    });
    setClothOptions(merged);
   } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetCloth_list = async ({
  pid,
  subid,
  setLoading,
  setClothOptions,
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("product-size", {
      subid: subid,
      page: 1,
      limit: 100,
      action: "product_size",
    });
    const resDataProduct = await apiGet("single_product_size", {
      pid: pid,
      page: 1,
      limit: 100,
    });
    if (resDataProduct?.data.length > 0) {
      const merged = resData?.data?.map((tItem) => {
        const match = resDataProduct?.data?.find(
          (sItem) => sItem.sid === tItem.sid
        );

        return match
          ? { ...tItem, ch_price: match.ch_price, ch_mrp: match.ch_mrp }
          : { ...tItem, ch_price: tItem.ps_mrp, ch_mrp: tItem.ps_price }; // unchanged if no match
      });
      setClothOptions(merged);
    } else {
      setClothOptions(resData?.data);
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetNormalSize_list = async ({
  data,
  setSizeOptions,
  setLoading,
  pid,
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("product-size", data);
    const resDataProduct = await apiGet("single_product_size", {
      pid: pid,
      page: 1,
      limit: 100,
    });

    if (resDataProduct?.data.length > 0) {
      const merged = resData?.data?.map((tItem) => {
        const match = resDataProduct?.data?.find(
          (sItem) => sItem.sid === tItem.sid
        );

        return match
          ? {
              ...tItem,
              ch_price: match.ch_price,
              ch_mrp: match.ch_mrp,
              qty: 0,
              s_mrp: match.ch_mrp,
              s_rate: match.ch_price,
              s_amount: 0,
            }
          : {
              ...tItem,
              ch_price: tItem.ps_whlprice,
              ch_mrp: tItem.ps_price,
              qty: 0,
              s_mrp: tItem.ps_price,
              s_rate: tItem.ps_whlprice,
              s_amount: 0,
            }; // unchanged if no match
      });
      setSizeOptions(merged);
    } else {
      const updatedPrices = resData?.data.map((item) => ({
        ...item,
        ch_price: item.ps_whlprice,
        ch_mrp: item.ps_price,
        qty: 0,
        s_mrp: 0,
        s_rate: 0,
        s_amount: 0,
      }));
      setSizeOptions(updatedPrices);
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetSize_list = async ({
  setLoading,
  setSizeOptions,
  quote,
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("sublimation", { page: 1, limit: 100 });
    if (quote?.length > 0) {
      const quantityMap = Object.fromEntries(
        quote?.[0]?.details?.map((q) => [
          q.item_size,
          {
            item_qty: q.item_qty,
            item_mrp: q.item_mrp,
            item_rate: q.item_rate,
            item_amount: q.item_amount,
          },
        ])
      );
      const updatedData = resData?.data?.map((product) => {
        const details = quantityMap[product.size_name] || {};
        return {
          ...product,
          qty: details.item_qty || 0,
          s_mrp: details.item_mrp || 0,
          s_rate: details.item_mrp || 0,
          s_amount: details.item_amount || 0,
          // Add more renamed fields here as needed
        };
      });
      setSizeOptions(updatedData);
    } else {
      const updatedData = resData?.data.map((item) => ({
        ...item,
        qty: 0,
      }));
      setSizeOptions(updatedData);
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetAddons_list = async ({
  setLoading,
  setAddonOptions,
  quote,
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("addons", { page: 1, limit: 100 });
    if (quote?.length > 0) {
      const quantityMap = Object.fromEntries(
        quote?.[0]?.addons?.map((q) => [
          q.addons_id,
          {
            addon_qty: q.addon_qty,
            addon_rate: q.addon_rate,
            addons_amount: q.addons_amount,
          },
        ])
      );
      const updatedData = resData?.data?.map((product) => {
        const details = quantityMap[product.id] || {};
        return {
          ...product,
          addon_qty: details?.addon_qty || 0,
          addons_amount: details?.addons_amount || 0,
          addons_price: details?.addon_rate || product?.addons_price,
        };
      });
      setAddonOptions(updatedData);
    } else {
      const updatedData = resData?.data.map((item) => ({
        ...item,
        addon_qty: 0,
        addons_amount: 0,
        addons_price: item?.addons_price,
      }));
      setAddonOptions(updatedData);
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetUser = async ({ setUser, id }) => {
  try {
    const resData = await apiGet("user-login", { id: id });
    // alert(JSON.stringify(resData?.data))
    setUser(resData?.data?.[0]);
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
  }
};

export const handleGetProduct = async ({ setProduct, id }) => {
  try {
    const resData = await apiGet("tbk-product", {
      id: id,
      action: "getProductDetail",
    });
    setProduct(resData?.data?.ProductData?.[0] || {});
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
  }
};

export const handleGetSettingGST = async ({ setGstPercent }) => {
  try {
    const resData = await apiGet("settings", { s_name: "gst percent" });
    setGstPercent(Number(resData?.data?.[0]?.s_value));
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
  }
};

export const handleGetSizeName = (item, selectedType,isSelect=0) => {
  if (selectedType == 1) {
    if(isSelect==0){
      return `${item?.size_no}`;
    }else{return `${item?.size_name}`;}
  } else {
    if(isSelect==0){
    return `${item?.size_no}`;
    }else{
      return `${item?.upper_size}`;
    }
  }
};

export const handleQuantityChange = (
  id,
  value,
  sizeOptions,
  setSizeOptions,
  rate,
  addonOptions,
  setAddonOptions
) => {
  const updatedOptions = sizeOptions.map((item) =>
    item.id === id
      ? {
          ...item,
          qty: value >= 0 ? value : 0,
          s_mrp: rate,
          s_rate: rate,
          s_amount: Number((value >= 0 ? value : 0) * rate).toFixed(2),
        }
      : item
  );
  setSizeOptions(updatedOptions);
};

export const handleSizePrice = (item) => {
  if (Number(item.ch_price).toFixed(2) > Number(0).toFixed(2)) {
    return item?.ch_price || 0;
  } else {
    return item?.ps_whlprice || 0;
  }
};

const handleShowValidation = (showModal, msg) => {
  showModal({
    title: "Validation",
    message: msg,
    onConfirm: () => {},
    confirmText: "Ok",
    cancelText: "Cancel",
  });
};

export const handleAddonQuantityChange = (
  id,
  value,
  addonOptions,
  setAddonOptions
) => {
  const updatedOptions = addonOptions.map((item) =>
    item.id === id
      ? {
          ...item,
          addon_qty: value >= 0 ? value : 0,
          addons_amount: Number(
            (value >= 0 ? value : 0) * item?.addon_rate
          ).toFixed(2),
        }
      : item
  );
  setAddonOptions(updatedOptions);
};

export const handleAddonQuantitySum = (sizeOptions) => {
  const sizeQty = sizeOptions.reduce(
    (sum, item) => sum + Number(item?.qty || 0),
    0
  );
  return Number(sizeQty).toFixed(0);
};

export const handleNext = ({
  activeStep,
  setActiveStep,
  selectedCloth,
  sizeOptions,
  documents,
  selectedType,
  addonOptions,
  showModal,
  steps,
  setLoading,
  data,
  navigate,selectedClothType,
  id,
}) => {
  if (activeStep === steps.length - 1) {
    handleSubmit({
      selectedCloth,
      sizeOptions,
      documents,
      selectedType,
      addonOptions,
      showModal,
      setActiveStep,
      setLoading,
      data,
      navigate,selectedClothType,
      id,
    });
    return;
  }

  if (activeStep === 1) {
    if (selectedCloth == "" || selectedCloth == undefined) {
      handleShowValidation(showModal, "Please select at least one print item.");
      return;
    }
  }else if (activeStep === 2) {
    if (selectedClothType == "" || selectedClothType == undefined) {
      handleShowValidation(showModal, "Please select at least one cloth item.");
      return;
    }
  } 
  else if (activeStep === 3) {
    const totalQty = sizeOptions.reduce(
      (sum, item) => sum + (item.qty || 0),
      0
    );
    if (totalQty < 10) {
      handleShowValidation(
        showModal,
        "Minimum quantity required is 10. Please update your order to proceed."
      );
      return;
    }
  }
  if (activeStep < steps.length - 1) setActiveStep((prev) => prev + 1);
};

export const handleBack = ({ activeStep, setActiveStep }) => {
  if (activeStep > 0) setActiveStep((prev) => prev - 1);
};

export const getAddons_submit = ({ addonOptions, quotations }) => {
  if (addonOptions?.length > 0) {  
    const result = addonOptions?.reduce((acc, item) => {
      const { id, addons_price, addons_amount, addon_qty } = item;
    
      // Find matched detail for current addon id
      const matchedAddon = quotations?.[0]?.addons?.find(
        (obj) => obj.addons_id === id
      );
    
      // Include if addon_qty > 0 OR existing record has an id
      const shouldInclude = addon_qty > 0 || Boolean(matchedAddon?.id);
    
      if (shouldInclude) {
        acc.push({
          addons_id: id,
          addon_rate: addons_price,
          addons_amount: addons_amount,
          addon_qty: addon_qty,
          ...(matchedAddon?.id && { id: matchedAddon.id }), // Include id if exists
        });
      }
    
      return acc;
    }, []);
    
    return result;
  }
};

export const getDetail_submit = ({ sizeOptions, product, quotations }) => {
  if (sizeOptions?.length > 0) {    
    const result = sizeOptions?.reduce((acc, item) => {
      const { size_name, qty, s_mrp, s_rate, s_amount } = item;
    
      // Find matched detail for current size_name
      const matchedDetail = quotations?.[0]?.details?.find(
        (obj) => obj.item_size === size_name
      );
    
      // Include if qty > 0 OR existing record has an id
      const shouldInclude = qty > 0 || Boolean(matchedDetail?.id);
    
      if (shouldInclude) {
        acc.push({
          item_main_id: product?.mpid,
          item_sub_id: product?.subid,
          item_id: product?.id,
          item_name: product?.productname,
          item_hsn: "",
          item_size: size_name,
          item_qty: qty,
          item_mrp: s_mrp,
          item_rate: s_rate,
          item_amount: s_amount,
          item_code: product?.productcode,
          ...(matchedDetail?.id && { id: matchedDetail.id }),
        });
      }
    
      return acc;
    }, []);
    
    return result;
     

  }
};

export const getDetailProduct_submit = ({
  sizeOptions,
  product,
  quotations,
}) => {
  if (sizeOptions?.length > 0) {    
    const result = sizeOptions?.reduce((acc, item) => {
      const { sizename, qty, s_mrp, s_rate, s_amount } = item;
    
      // Find matched detail for current size_name
      const matchedDetail = quotations?.[0]?.details?.find(
        (obj) => obj.item_size === sizename
      );
    
      // Include if qty > 0 OR existing record has an id
      const shouldInclude = qty > 0 || Boolean(matchedDetail?.id);
    
      if (shouldInclude) {
        acc.push({
          item_main_id: product?.mpid,
          item_sub_id: product?.subid,
          item_id: product?.id,
          item_name: product?.productname,
          item_hsn: "",
          item_size: sizename,
          item_qty: qty,
          item_mrp: s_mrp,
          item_rate: s_rate,
          item_amount: s_amount,
          item_code: product?.productcode,
          ...(matchedDetail?.id && { id: matchedDetail.id }), // only add id if exists
        });
      }
    
      return acc;
    }, []);
    
    return result;
  }
};

export const getPrintAddons_submit = ({
  printAddons,  
  quotations,
}) => {
  if (printAddons?.length > 0) {    
    const result = printAddons?.reduce((acc, item) => {
      const { print_addon_name, addon_is,id} = item;
    
      // Find matched detail for current size_name
      const matchedDetail = quotations?.[0]?.prints?.find(
        (obj) => obj.print_addon_id === id
      );
    
      // Include if qty > 0 OR existing record has an id
      const shouldInclude = addon_is == true || Boolean(matchedDetail?.id);
    
      if (shouldInclude) {
        acc.push({
          print_addon_id: id,
          print_name: print_addon_name,
          addon_is:addon_is,              
          ...(matchedDetail?.id && { id: matchedDetail.id }), // only add id if exists
        });
      }
    
      return acc;
    }, []);
    
    return result;
  }
};

export const getCalc_submit = ({
  gstPercent,
  addonOptions,
  sizeOptions,
  isType,
}) => {
  const sizeAmount = sizeOptions?.reduce(
    (sum, item) => sum + Number(item?.s_amount || 0),
    0
  );
  const addonAmount = addonOptions?.reduce(
    (sum, item) => sum + Number(item?.addons_amount || 0),
    0
  );
  let subTotal = Number(sizeAmount) + Number(addonAmount);
  subTotal = Number(subTotal).toFixed(2);
  const gst = Number(gstPercent).toFixed(2);
  const totalGst = Number((subTotal * gst) / 100).toFixed(2);
  const cgst = Number(totalGst / 2).toFixed(2);
  const sgst = Number(totalGst / 2).toFixed(2);
  const grandTotal = Number(totalGst) + Number(subTotal);
  // alert(grandTotal)

  switch (isType) {
    case "addon":
      return Number(addonAmount).toFixed(2);
    case "sub":
      return Number(subTotal).toFixed(2);
    case "size":
      return Number(sizeAmount).toFixed(2);
    case "gst":
      return Number(cgst).toFixed(2);
    case "grand_total":
      return Number(grandTotal).toFixed(2);

    default:
      break;
  }
};

export const handleSubmit = async ({
  selectedCloth,
  sizeOptions,
  showModal,
  setActiveStep,
  setLoading,
  data,
  navigate,
  id,
}) => {
  const isLogin = handleCheckUserLogin("userData", "id");
  if (isLogin <= 0) {
    window.location.href="/";
    return;
  }
  const totalQty = sizeOptions.reduce((sum, item) => sum + (item.qty || 0), 0);

  if (selectedCloth == "" || selectedCloth == undefined) {
    handleShowValidation(showModal, "Please select at least one print item.");
    setActiveStep(1);
    return;
  } else if (totalQty < 10) {
    handleShowValidation(
      showModal,
      "Minimum quantity required is 10. Please update your order to proceed."
    );
    setActiveStep(3);
    return;
  }

  setLoading(true);
  try {
    let resData = {};
    if (id > 0) {
      let newData = { ...data, id: id };
      resData = await apiUpdate("quotation", newData);
    } else {
      resData = await apiAdd("quotation", data);
    }
    // alert(JSON.stringify(resData))
    if (resData?.data > 0) {
      showModal({
        title: "Success",
        message: "Thank you! Your order has been placed successfully.",
        onConfirm: () => {
          navigate("/");
        },
        onCancel: () => {
          navigate("/");
        },
        confirmText: "Ok",
        cancelText: "Cancel",
      });
    } else {
      showModal({
        title: "Error",
        message: "Something went wrong! Please try again.",
        onConfirm: () => {},
        confirmText: "Ok",
        cancelText: "Cancel",
      });
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleSubmit_product = async ({
  sizeOptions,
  showModal,
  setSubmitLoading,
  data,
  navigate,
  id,
}) => {
  const isLogin = handleCheckUserLogin("userData", "id");
  if (isLogin <= 0) {
    window.location.href="/";
    return;
  }
  const totalQty = sizeOptions.reduce((sum, item) => sum + (item.qty || 0), 0);
  if (totalQty <= 0) {
    handleShowValidation(
      showModal,
      "You must enter quantity for at least one size to continue."
    );
    return;
  }
  setSubmitLoading(true);
  try {
    let resData = {};
    if (id > 0) {
      let newData = { ...data, id: id };
      resData = await apiUpdate("quotation", newData);
    } else {
      resData = await apiAdd("quotation", data);
    }
    if (resData?.data > 0) {
      showModal({
        title: "Success",
        message: "Thank you! Your order has been placed successfully.",
        onConfirm: () => {
          navigate("/");
        },
        onCancel: () => {
          navigate("/");
        },
        confirmText: "Ok",
        cancelText: "Cancel",
      });
    } else {
      showModal({
        title: "Error",
        message: "Something went wrong! Please try again.",
        onConfirm: () => {},
        confirmText: "Ok",
        cancelText: "Cancel",
      });
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setSubmitLoading(false);
  }
};

export const handleQuoteDelete=async({id,
  quotations,setQuotations,showToast,setActionLoading})=>{  
  try {    
    setActionLoading({deleteId:id})
    const resData=await apiDelete('quotation',{id:id}) 
    if(resData?.data > 0)   
    {
      const updatedData = quotations.filter(item => item.id !== id);
      showToast(`Your order has been successfully cancelled.`, 'success');
      setQuotations(updatedData);
    }else{
      showToast("Something went wrong! Please try again", 'danger');  
    }
  } catch (error) {
    showToast("Something went wrong! Please try again", 'danger');
  }finally{
    setActionLoading({})
  }
}

export const handleCancel_Order=({showModal,id,
  quotations,setQuotations,showToast,setActionLoading})=>{
  showModal({
    title: "Confirmation",
    message: "Are you sure you want to cancel this order?",
    onConfirm: () => {
      handleQuoteDelete({id,quotations,setQuotations,showToast,setActionLoading})
    },
    onCancel: () => {      
    },
    confirmText: "Yes",
    cancelText: "No",
  });
}